import { render, staticRenderFns } from "./InventoryCRUD.vue?vue&type=template&id=6ceb871d&scoped=true&"
import script from "./InventoryCRUD.vue?vue&type=script&lang=js&"
export * from "./InventoryCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb871d",
  null
  
)

export default component.exports